export default "__VITE_ASSET__B5OYjXEH__"